// extracted by mini-css-extract-plugin
export default {"pageDescription":"ProjectsEmployeesPage_pageDescription__lJ-Jj"};